// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1066":"bd005ded","6453":"0403cac3"}[chunkId] + ".chunk.js";
};